import { TimelineModule } from "./timeline.module";
import { TimelineStarter } from "./timeline.provider";

export const VideoTimeline = () => {
  return (
    <TimelineStarter>
      <TimelineModule />
    </TimelineStarter>
  )
}